import axios from 'axios'

export const AdminCodeBookService = {
  /**
   * @param {*} status blank is for both status(published and inactive)
   * status = 1 ==> for inactive
   * status = 2 ==> for published
   */
  fetchCodeBookList (status = '') {
    if (status !== '') {
      return axios.get(`/api/v1/codebooklist/${status}`)
    } else {
      return axios.get('/api/v1/codebooklist')
    }
  },
  searchCodeBookList (data) {
    let queryArray = []
    if (data.title !== undefined && data.title !== '') {
      queryArray.push('title=' + data.title)
    }
    if (data.status !== undefined && data.status !== '') {
      queryArray.push('status=' + data.status)
    }
    if (data.publisherId !== undefined && data.publisherId !== '') {
      queryArray.push('publisherId=' + data.publisherId)
    }
    if (data.id !== undefined && data.id !== '') {
      queryArray.push('id=' + data.id)
    }
    if (data.yearId !== undefined && data.yearId !== '') {
      queryArray.push('yearId=' + data.yearId)
    }
    let queryParams = '?'
    queryParams += queryArray.join('&')
    return axios.get(`/api/v1/codebooklist${queryParams}`)
  },
  /**
   * edit code book record
   */
  editCodeBookItem (data) {
    return axios.post(`/api/v1/editcodebook`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    )
  },
  /**
   * Add new code book record
   */
  addNewCodeBookItem (data) {
    return axios.post(`/api/v1/addcodebook`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    )
  },
  importCodebookFile (data) {
    return axios.post(
      `/api/v1/importbook`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'CURLOPT_TIMEOUT': '0'
        }
      }
    )
  },
  deleteImage (data) {
    return axios.post(`/api/v1/deleteimage`, JSON.stringify({
      userId: data.userId,
      id: data.id,
      adoptionLevel: data.adoptionLevel
    }))
  },
  validateCodeBookItem (data) {
    return axios.delete(`/api/v1/deletecodebook`, { data: data })
  },
  deleteCodeBookItem (data) {
    return axios.delete(`/api/v1/deletecodebook`, { data: data })
  }
}
